/* import __COLOCATED_TEMPLATE__ from './expanded.hbs'; */
import Component from '@glimmer/component';
import PlaylistPlayerAbstract from './abstract';

export default class PlaylistPlayerExpandedComponent extends PlaylistPlayerAbstract {}
